import React from "react";
import { Button } from "@/components/ui/button";
import { PlayCircle, Video } from "lucide-react";

const HERO_IMG = "https://images.pexels.com/photos/34328510/pexels-photo-34328510.jpeg";

export default function Hero({ info }) {
  return (
    <section id="accueil" className="relative min-h-[92vh] flex items-center justify-center overflow-hidden">
      <img
        src={HERO_IMG}
        alt="Culte à l'église"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-deepblue-800/70 via-deepblue-700/55 to-deepblue-900/75" />
      <div className="absolute inset-0 grain" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-gold text-xs tracking-[0.25em] uppercase mb-8 backdrop-blur">
          <span className="w-1.5 h-1.5 rounded-full bg-gold" />
          Bienvenue chez nous
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl lg:text-7xl font-semibold text-white leading-[1.05] tracking-tight">
          {info?.slogan?.split(",").map((chunk, i, arr) => (
            <span key={i} className="block">
              {chunk.trim()}{i < arr.length - 1 ? "," : ""}
            </span>
          )) || "Un lieu de foi, d'amour et d'espérance"}
        </h1>

        <div className="gold-divider my-10 max-w-md mx-auto">
          <span className="text-2xl">✦</span>
        </div>

        <p className="max-w-2xl mx-auto text-white/85 text-lg leading-relaxed font-light">
          Que vous soyez de passage ou en recherche de sens, notre communauté vous accueille
          chaleureusement pour vivre une rencontre authentique avec Dieu.
        </p>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a href="#direct" data-testid="hero-live-btn">
            <Button size="lg" className="bg-[#D4AF37] hover:bg-[#C59B27] text-white rounded-full px-8 py-6 text-base shadow-2xl shadow-black/40 group">
              <PlayCircle className="w-5 h-5 mr-2 group-hover:scale-110 transition-transform" />
              Suivre le culte en direct
            </Button>
          </a>
          <a href="#cultes" data-testid="hero-archives-btn">
            <Button size="lg" variant="outline" className="bg-transparent border-white/70 text-white hover:bg-white hover:text-deepblue-900 rounded-full px-8 py-6 text-base">
              <Video className="w-5 h-5 mr-2" />
              Voir les cultes passés
            </Button>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 text-white/60 text-xs tracking-[0.3em] uppercase">
        Défiler pour découvrir
      </div>
    </section>
  );
}
